<template>
  <v-container fluid>
    <v-progress-linear v-if="loading" indeterminate color="deep-purple" />
    <h5 class="grey--text">Vista general</h5>
    <v-row>
      <v-col md="6">
        <h2 class="deep-purple--text lighten-3">{{ $t('users.all_users') }}</h2>
      </v-col>
    </v-row>
    <users-filter v-model="params" @search="search(true)" />
    <users-data-table
      :table-loading="loading"
      v-model="page"
      :items="users"
      :length="totalPages"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import UsersFilter from '../../components/core/filters/UsersFilter.vue';
import UsersDataTable from '../../components/users/UsersDataTable.vue';
import LoadingMixin from '../../mixins/loading';
import userService from '../../services/user.service';
import { defaultUsersFilter } from '../../constants/filters';

export default {
  name: 'Users',
  components: {
    UsersFilter,
    UsersDataTable,
  },
  mixins: [LoadingMixin],
  data: () => ({
    page: 1,
    params: { ...defaultUsersFilter },
  }),
  async mounted() {
    await this.search();
  },
  computed: {
    ...mapState({
      users: ({ enrollment: { users } }) => users,
      totalPages: ({ enrollment: { usersTotalPages } }) => usersTotalPages,
    }),
  },
  methods: {
    ...mapActions('enrollment', ['setUsersDataTable']),
    async search(reset = false) {
      this.loader();
      if (reset) this.page = 1;

      // Build params, omitting null userType so the API returns all types
      const queryParams = { ...this.params };
      if (queryParams.userType === null || queryParams.userType === undefined) {
        delete queryParams.userType;
      }

      const { data: { data, total_page: totalPages }, status } = await userService.findAllByParameters(
        this.page,
        queryParams,
      );

      if (status === 200) {
        this.setUsersDataTable({ data, totalPages });
      }
      this.loader();
    },
  },
  watch: {
    page() {
      this.search();
    },
  },
};
</script>
